import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPatchWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
	searchsConventionApi,
	searchsConventionApiBy
} from 'interface/endpoints'
import {
	SearchsConventionFormData,
  SearchsConventionResult,
  SearchsConventionResultList
} from './types'

export * from './types'

export const useListSearchsConvention = (
  searchId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId) return null
      return ApiGetWithToken<SearchsConventionResultList>(
        apiAccess,
        searchsConventionApi(searchId, "/list"),
        cancelToken
  		)
    },
		[searchId]
	)
)

export const useGetSearchsConvention = (
  searchId?: number | null,
	searchsConventionId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId || !searchsConventionId) return null
      return ApiGetWithToken<SearchsConventionResult>(
        apiAccess,
        searchsConventionApiBy(searchId, searchsConventionId),
        cancelToken
  		)
    },
		[searchId, searchsConventionId]
	)
)

export const usePostSearchsConvention = (
  searchId: number, 
	callback?: {
    onPosted?: (result: SearchsConventionResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsConventionFormData, SearchsConventionResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsConventionApi(searchId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditSearchsConvention = (
  searchId: number, searchsConventionId: number, 
	callback?: {
    onEditted?: (result: SearchsConventionResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsConventionFormData, SearchsConventionResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        searchsConventionApiBy(searchId, searchsConventionId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, searchsConventionId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useSortSearchsConvention = (
  searchId: number,
	callback?: {
    onPosted?: (result: SearchsConventionResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number[], SearchsConventionResult>(
	useCallback(
		(apiAccess, cancelToken, ids, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsConventionApi(searchId, "/sort"),
				ids,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useRemoveSearchsConvention = (
	searchId: number, 
  callback?: {
    onDeleted?: (searchsConventionId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, searchsConventionId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        searchsConventionApiBy(searchId, searchsConventionId),
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
